import { styled } from 'styled-components'

export const Container = styled.div`
  pointer-events: all;
  width: fit-content;
  margin: auto;
`
